import Input from "components/Input";
import PillButton from "components/button/Pills";
import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import httpClient from "services/network/httpClient";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { showToast } from "components/Toaster";

const schema = yup.object().shape({
  cropName: yup.string().required("Crop Name Is Required"),
});

interface EditProps {
  data: any;
  onClose: () => void;
  getData: () => void;
}

const EditCrops = ({ data, onClose, getData }: EditProps) => {
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: { ...data },
  });

  const onsubmit = (newData: any) => {
    httpClient
      .put(`crop/update`, newData)
      .then((res: any) => {
        console.log(res);
        if (res.success === true) {
          showToast("Crop updated successfully", "success");
        } else {
          showToast(`${res.error.message}`, "error");
        }
      })
      .catch((error) => {
        console.log(error);
        showToast("Something went wrong", "error");
      })
      .finally(() => {
        console.info("Finally block");
        onClose();
        getData();
      });
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onsubmit)}>
        <Input name={"cropName"} label={"Crop Name"} required></Input>
        <div className="flex flex-row items-center justify-end gap-5">
          <PillButton type="submit" variant="secondary">
            Submit
          </PillButton>
          <PillButton type="button" variant="primary" onClick={onClose}>
            Cancel
          </PillButton>
        </div>
      </form>
    </FormProvider>
  );
};

export default EditCrops;
